import { cx } from '@/lib/cx';

export type TomCarimbo = 'sucesso' | 'perigo' | 'alerta' | 'info' | 'neutro';

const TONS: Record<TomCarimbo, string> = {
  sucesso: 'text-sucesso',
  perigo: 'text-perigo',
  alerta: 'text-alerta',
  info: 'text-info',
  neutro: 'text-texto-suave',
};

interface CarimboProps {
  tom: TomCarimbo;
  children: string;
  className?: string;
}

/**
 * Situação de um documento como carimbo de tinta. A `key` pelo texto faz o carimbo "bater" de
 * novo (animação curta) quando a situação muda — é o que mostra ao olho o que mudou.
 */
export function Carimbo({ tom, children, className }: CarimboProps) {
  return (
    <span
      key={children}
      className={cx(
        'carimbo inline-flex items-center whitespace-nowrap px-1.5 py-px text-xs font-semibold animate-carimbar',
        TONS[tom],
        className,
      )}
    >
      {children}
    </span>
  );
}
